export default __webpack_public_path__ + "static/media/volume.07f5b9b6.svg";